import { objectToQueryString, downloadFile } from "../api";

export const downloadClientSummary = async (isDisabled, filters = {}) => {
  const queryString = objectToQueryString(filters);
  const url = `export/clientSummary?isdisabled=${isDisabled}${queryString ? '&' + queryString : ''}`;
  let response = await downloadFile(url, {});
  return response;
}

export const downloadServiceLookup = async () => {
  const url = 'export/ServiceNameIdLookup';
  let response = await downloadFile(url, {});
  return response;
}
export const downloadProgramLookup = async () => {
  const url = 'export/ProgramNameIdLookup';
  let response = await downloadFile(url, {});
  return response;
}

export const downloadStaffData = async () => {
  const url = 'export/StaffWithRoles';
  let response = await downloadFile(url, {});
  return response;
}

export const downloadClientAssignmentData = async () => {
  const url = 'export/ClientStaffAssignments';
  let response = await downloadFile(url, {});
  return response;
}

export const downloadProgramMeasureDataAuditLog = async (dateRangeDto) => {
  const url = 'export/ProgramAuditLog';
  let response = await downloadFile(url, { method: 'POST', body: dateRangeDto });
  return response;
}

export const downloadClientDataAuditLog = async (dateRangeDto) => {
  const url = 'export/ClientAuditLog';
  let response = await downloadFile(url, { method: 'POST', body: dateRangeDto });
  return response;
}

export const downloadClientEnrollmentDataAuditLog = async (dateRangeDto) => {
  const url = 'export/ClientEnrollmentAuditLog';
  let response = await downloadFile(url, { method: 'POST', body: dateRangeDto });
  return response;
}

export const downloadClientServiceActivityDataAuditLog = async (dateRangeDto) => {
  const url = 'export/ClientServiceActivityAuditLog';
  let response = await downloadFile(url, { method: 'POST', body: dateRangeDto });
  return response;
}
export const downloadClientMeasureDataAuditLog = async (dateRangeDto) => {
  const url = 'export/GetClientMeasureDataAuditLog';
  let response = await downloadFile(url, { method: 'POST', body: dateRangeDto });
  return response;
}

export const downloadMeasureFieldInfo = async () => {
  const url = 'export/MeasureFieldInfo';
  let response = await downloadFile(url, {method: 'GET'});
  return response;
}






